import { isNullOrEmpty } from '@powerduck/common/utils/is-null-or-empty';

/**
 * Tracks whether the SPA was entered with an embed Token.
 *
 * Iframe hosts - the promoter app's stats screen is the main one - authenticate
 * with a `Token` query param instead of signing in. The hosted page turns it
 * into the `inv-token` request header (see pages/stats/stats-personal), so no
 * session cookie is ever set and `AppState.user` stays null.
 *
 * The router's auth guard therefore cannot use "no user" to mean "anonymous":
 * doing so aborts the navigation, the page never mounts, and hosts waiting on a
 * ready postMessage (`inv-stats-ready`) hang on their preloader forever.
 *
 * The result is sticky because pages rewrite the URL without the token once
 * they have read it, so later in-app navigations no longer carry it.
 */
export const createEmbedTokenTracker = (): ((query: Record<string, unknown>) => boolean) => {
	let seen = false;

	return (query: Record<string, unknown>): boolean => {
		if (!seen && query != null) {
			for (const key in query) {
				if (key.toLowerCase() == 'token' && !isNullOrEmpty(query[key] as string)) {
					seen = true;
					break;
				}
			}
		}

		return seen;
	};
};
